import React from 'react';
import { Redirect } from 'react-router-dom';

const IndexRedirect = () => {
    const token = JSON.parse(localStorage.getItem('scality-credentials'));
    const type = JSON.parse(localStorage.getItem('scality-usertype'));

    if (!token) {
        return <Redirect to="/login"/>;
    }
    if (type === 'superadmin') {
        return <Redirect to="/accounts"/>;
    }
    return <Redirect to="/users"/>;
};

export default IndexRedirect;



/** WEBPACK FOOTER **
 ** ./src/utils/routing/IndexRedirect.js
 **/